'use client';
import { Toast, ToastClose, ToastProvider, ToastViewport } from './toast';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="up">
      {toasts.map(({ id, content, action, ...props }) => {
        return (
          <Toast key={id} {...props}>
            <div className="flex-1 text-center">{content}</div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
